import { render } from "./BtnPagetop.vue?vue&type=template&id=516e3f7a&scoped=true"
import script from "./BtnPagetop.vue?vue&type=script&lang=js"
export * from "./BtnPagetop.vue?vue&type=script&lang=js"

import "./BtnPagetop.vue?vue&type=style&index=0&id=516e3f7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516e3f7a"]])

export default __exports__